import { render } from "./GoodsPage.vue?vue&type=template&id=7060fa13&scoped=true"
import script from "./GoodsPage.vue?vue&type=script&lang=js"
export * from "./GoodsPage.vue?vue&type=script&lang=js"

import "./GoodsPage.vue?vue&type=style&index=0&id=7060fa13&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7060fa13"

export default script